<template>
  <div class="app-at-a-glance-table">
    <div class="app-at-a-glance-table__button-container">
      <button
        class="app-at-a-glance-table__toggle-button"
        :class="showForecast ? 'active' : ''"
        @click="toggle('forecast')"
      >
        VIEW FORECAST
      </button>
      <button
        class="app-at-a-glance-table__toggle-button"
        :class="!showForecast ? 'active' : ''"
        @click="toggle('charts')"
      >
        VIEW CHARTS
      </button>
    </div>
    <div
      class="app-at-a-glance-table__table"
      v-for="(data, index) in cwa_data"
      :key="index"
    >
      <AppAtAGlanceTableHeaderRow
        :rowData="data.ColumnHeaders"
        :showForecast="showForecast"
        :isFirstRow="index === 0"
      />
      <AppAtAGlanceTableIndicatorRow
        v-for="(rowData, secondIndex) in visibleRowData(data.IndicatorData)"
        :key="secondIndex"
        :rowData="rowData"
        :userAags="user_aags"
        :fromDashboard="my_aag"
        :showForecast="showForecast"
        :appUrl="properPath"
        :isLastRow="
          secondIndex == data.IndicatorData.length - 1 &&
          parseInt(index) === cwa_data.length - 1
        "
        @remove-aag="removeAAG($event)"
        @add-aag="addAAG($event)"
      />
    </div>
    <div v-if="showButton" class="app-at-a-glance-table__expand-button">
      <div @click="expand = !expand" class="table-button">
        <div class="button-text">
          {{ expand ? 'COLLAPSE TABLE' : 'EXPAND TABLE' }}
        </div>
        <div class="button-icon">
          <IconChevronCircleDown :isActive="!expand" :height="20" :width="20" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppAtAGlanceTableHeaderRow from '~/components/trendsreport/html/AtAGlanceComponents/AppAtAGlanceTableHeaderRow.vue';
  import AppAtAGlanceTableIndicatorRow from '~/components/trendsreport/html/AtAGlanceComponents/AppAtAGlanceTableIndicatorRow.vue';
  import IconChevronCircleDown from '~/components/icon/IconChevronCircleDown.vue';
  export default {
    name: 'AppAtAGlanceTable',
    components: {
      AppAtAGlanceTableHeaderRow,
      AppAtAGlanceTableIndicatorRow,
      IconChevronCircleDown,
    },
    props: {
      cwa_data: {
        type: Object,
        required: true,
      },
      my_aag: {
        type: [Boolean, Number],
        default: 0,
      },
      user_aags: {
        type: Object,
        required: false,
      },
      app_url: {
        type: String,
        required: false,
      },
      imagespath: {
        type: String,
        required: false,
      }
    },
    mounted() {
      this.threshold = this.cwa_data.length < 3 ? 4 : 2;
    },
    data() {
      return {
        showForecast: true,
        expand: localStorage.getItem('myaag-table-state')
          ? JSON.parse(localStorage.getItem('myaag-table-state'))
          : false,
        threshold: 2,
      };
    },
    computed: {
      showButton() {
        if (!this.my_aag) {
          return false;
        }
        return this.cwa_data.some(
          (data) => data.IndicatorData.length > this.threshold
        );
      },
      properPath() {
        if(this.app_url) return this.app_url;
        if(this.imagespath) return this.imagespath;
        return '';
      }
    },
    methods: {
      toggle(view) {
        if (view === 'forecast') {
          this.showForecast = true;
        }
        if (view === 'charts') {
          this.showForecast = false;
        }
      },
      visibleRowData(data) {
        if (this.showButton && !this.expand) {
          return data.slice(0, this.threshold);
        }
        return data;
      },
      addAAG(data) {
        const query = new URLSearchParams(data).toString();
        const invokeUrl = `invoke://tr-add-aag?${query}`;
        window.location.href = invokeUrl;
      },
      removeAAG(data) {
        const query = new URLSearchParams(data).toString();
        const invokeUrl = `invoke://tr-remove-aag?${query}`;
        window.location.href = invokeUrl;
      },
    },
  };
</script>
<style scoped lang="scss">
  .app-at-a-glance-table {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    &__button-container {
      display: flex;
      align-items: center;
      // justify-content: center;
      justify-content: space-between;
      margin-bottom: 1rem;
    }
    &__toggle-button {
      background-color: var(--itr-grey-mid);
      color: var(--itr-white);
      padding: 8px 26px;
      font-size: 12px;
      font-weight: bold;
      border-radius: 4px;
      transition: background-color 0.25s ease-in-out;
      // margin: 0 1rem;
      &.active {
        background-color: var(--itr-green-mid);
      }
    }
    &__expand-button {
      margin: 0 auto;
      margin-top: 1rem;
      .table-button {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--itr-green-mid);
        color: var(--itr-white);
        padding: 2px 16px;
        font-size: 12px;
        font-weight: bold;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.25s ease-in-out;

        .button-text {
          margin-right: 10px;
          text-transform: uppercase;
        }
        .button-icon {
          
        }
      }
    }
  }
</style>
